import { render, staticRenderFns } from "./ShapeItemNew.vue?vue&type=template&id=67bfea2a&scoped=true&"
import script from "./ShapeItemNew.vue?vue&type=script&lang=js&"
export * from "./ShapeItemNew.vue?vue&type=script&lang=js&"
import style0 from "./ShapeItemNew.vue?vue&type=style&index=0&id=67bfea2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bfea2a",
  null
  
)

export default component.exports